export default (session, { payload }) => {
    const {
        Hall,
        Sector,
        Row,
        Seat,
    } = session;

    const {
        id,
        seats_json_data,
        rows,
        sector_json: sectorItem,
    } = payload;

    const { itemsById: seatItems } = seats_json_data;

    const currentSector = Sector.withId(id);
    if (currentSector) {
        currentSector.delete();
    }

    Object.values(seatItems).forEach((seatItem) => {
        if (typeof seatItem.row !== 'undefined') {
            const seatWithId = Seat.withId(seatItem.id);
            if (seatWithId) {
                seatWithId.delete();
            }
            Seat.create(seatItem);
        }
    });

    rows.forEach((rowItem) => {
        const rowWithId = Row.withId(rowItem.id);
        if (rowWithId) {
            rowWithId.delete();
        }
        Row.create(rowItem);
    });

    const sectorWithId = Sector.withId(id);
    if (sectorWithId) {
        sectorWithId.delete();
    }

    sectorItem.initializedWithSeats = true;
    Sector.create(sectorItem);

    Object.values(seatItems).forEach((seatItem) => {
        if (typeof seatItem.row !== 'undefined') {
            const row = Row.withId(seatItem.row);
            if (row) {
                row.seats.add(seatItem.id);
            }
        }
    });

    rows.forEach((rowItem) => {
        if (typeof rowItem.sector === 'number') {
            const sector = Sector.withId(rowItem.sector);
            sector.rows.add(rowItem.id);
        }
    });

    const hall = Hall.all().first();
    if (hall) {
        hall.sectors.add(sectorItem.id);
    }
};
